import { render, staticRenderFns } from "./BaseInformation.vue?vue&type=template&id=7b396ac6&scoped=true"
import script from "./BaseInformation.vue?vue&type=script&lang=ts"
export * from "./BaseInformation.vue?vue&type=script&lang=ts"
import style0 from "./BaseInformation.vue?vue&type=style&index=0&id=7b396ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b396ac6",
  null
  
)

export default component.exports